import { render, staticRenderFns } from "./orderSaleDataDivide.vue?vue&type=template&id=0ec79b0a&scoped=true&"
import script from "./orderSaleDataDivide.vue?vue&type=script&lang=js&"
export * from "./orderSaleDataDivide.vue?vue&type=script&lang=js&"
import style0 from "./orderSaleDataDivide.vue?vue&type=style&index=0&id=0ec79b0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec79b0a",
  null
  
)

component.options.__file = "orderSaleDataDivide.vue"
export default component.exports